module.exports = __webpack_public_path__ + "static/media/photo-1571613316887-6f8d5cbf7ef7.fb811596.jpg";